import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';

const ListKhandShreniWiseSummary = () => {

  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const { Id, Name } = useParams();


  const fetchKhandGurudakshinaSummary = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`get-khand-gurudakshina-summary?khand_id=${Id}`, {
        withCredentials: true,
      });
      const khandList = response.data;
      setGurudakshinas(response.data);
      setLoading(false);


    } catch (error) {
      console.error("Error fetching khand gurudakshina summary:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate, Id]); // 👈 dependency added



  useEffect(() => {
    fetchKhandGurudakshinaSummary();
  }, [Id]);


  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }


  const sakhas = ["Vidyarthi Samyuktha", "Prouda", "Vidyarthi Tharuna", "Vyavasayi Tharuna"];
  const shrenis = ["Bala", "Tharuna", "Prouda"];

  // Transform API into a lookup
  const dataMap = {};
  gurudakshinas.forEach(item => {
    if (!dataMap[item.sakha]) dataMap[item.sakha] = {};
    dataMap[item.sakha][item.shreni] = {
      upasthith: item.upasthith,
      amount: item.amount
    };
  });
  return (
    <>

      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Khand Shreni–wise Summary of <span className="colorChange">{Name}</span>   Khand</h3>

          <div className="table-container">
            <table id="customers" border="1" cellSpacing="0" cellPadding="6">
              <thead>
                <tr>
                  <th rowSpan="2"></th>
                  {sakhas.map(sakha => (
                    <th key={sakha} colSpan="2">{sakha}</th>
                  ))}
                </tr>
                <tr>
                  {sakhas.map(sakha => (
                    <>
                      <th key={sakha + "-up"}>Upasthith</th>
                      <th key={sakha + "-amt"}>Amount</th>
                    </>
                  ))}
                </tr>
              </thead>

              <tbody>
                {shrenis.map(shreni => (
                  <tr key={shreni}>
                    <th>{shreni}</th>
                    {sakhas.map(sakha => {
                      const entry = dataMap[sakha]?.[shreni] || { upasthith: 0, amount: 0 };
                      return (
                        <>
                          <td>{entry.upasthith}</td>
                          <td>{entry.amount}</td>
                        </>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>


        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListKhandShreniWiseSummary;
